import React, { useEffect } from 'react';
import '../styles/Pages.css';
const EditoraIluminada = () => {

    const images = [
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/426fcc158491985.638e3d4b6e401.gif',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/5224fb158491985.638e48eb96743.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/fef5e0158491985.638e48eb98967.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/c08079158491985.638e48eb91762.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/8e776d158491985.638e48eb8f274.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/4ff624158491985.638e48eb93743.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/30df81158491985.638e48eb9ac21.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/625f0f158491985.638e48eb958d4.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/255461158491985.638e48eb99b1b.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/9301e7158491985.63c5e20a6f9fe.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/0bf28e158491985.638e48eb92798.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/729578158491985.638e4b9be5437.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/8fe2f8158491985.638e4b9be6580.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/bc4cfd158491985.63c5e20a6e5b3.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/5c26a2158491985.638e4b9be32cd.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/3281a0158491985.638e4b9be43c1.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/db9390158491985.6397375c45ee5.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/f3be1a158491985.638e48eb977c8.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/31c0f3158491985.638e48eb90608.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/edef6b158491985.63c5e20a70d73.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/dd6dbb158491985.638e48eb949f7.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/658dda158491985.6397375c46f81.jpg'
    ];

    useEffect(() => {
        window.scrollTo(0, 0);

        // Adicionar o Google Analytics
        const gtagScript = document.createElement('script');
        gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-ETQFHX8NN9';
        gtagScript.async = true;
        document.head.appendChild(gtagScript);

        const gtagConfigScript = document.createElement('script');
        gtagConfigScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-ETQFHX8NN9');
        `;
        document.head.appendChild(gtagConfigScript);

        return () => {
            // Cleanup quando o componente for desmontado (opcional)
            document.head.removeChild(gtagScript);
            document.head.removeChild(gtagConfigScript);
        };

      }, []);

    return (
        <div className="pages-container">
            <div className="pages-text">
                <div className="pages-left">
                    <h1>Editora Iluminada</h1>
                    <p className="subtitle">A editora que traz luz à mente</p>
                </div>
                <div className="pages-right">
                    <p className="description">
                        A Editora Iluminada é um trabalho fictício de uma editora de livros que tem como objetivo iluminar as mentes dos leitores através de contos e romances literários de diversos autores.<br/>
                        Os desenhos ondulados e as formas circulares têm o intuito de transmitir suavidade e calma, que simbolizam a leveza e o silêncio da leitura. Já as cores representam o conhecimento e o amor que as histórias literárias passam.
                    </p>
                </div>
            </div>

            <div className="pages-panel">
                {images.map((url, index) => (
                    <img key={index} src={url} alt={`Centro de Convivência Imagem ${index + 1}`} className="pages-image" />
                ))}
            </div>
        </div>
    );
};

export default EditoraIluminada;
